var Binding = /** @class */ (function () {
    function Binding(param) {
        var _this = this;
        var obj;
        if (typeof param === 'string') {
            obj = JSON.parse(param);
        }
        else {
            obj = param;
        }
        if (!obj) {
            return;
        }
        var keys = 'type,target,path';
        Object.keys(obj).forEach(function (key) {
            if (keys.includes(key)) {
                _this[key] = obj[key];
            }
        });
    }
    Binding.prototype.toJSON = function () {
        return {
            "type": this.type,
            "target": this.target,
            "path": this.path
        };
    };
    Binding.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return Binding;
}());
export { Binding };
//# sourceMappingURL=binding.js.map